document.addEventListener('DOMContentLoaded', function() {
  // Init gate background WebGL, then fade in + cascade
  var bgGateSrc = document.getElementById('bg-gate').dataset.bgSrc;
  initWebGL('bg-gate', bgGateSrc);
  var bgGateCanvas = document.getElementById('bg-gate');
  var gateCard = document.querySelector('.gate-card');

  // Age gate elements
  var gate = document.getElementById('age-gate');
  var home = document.getElementById('home');
  var btnYes = document.getElementById('btn-yes');
  var btnNo = document.getElementById('btn-no');

  // Skip gate if cookie exists
  if (document.cookie.includes('age_verified=1')) {
    gate.style.display = 'none';
    home.style.display = 'block';
    document.getElementById('section2').style.display = 'block';
    var labSec = document.getElementById('lab-section');
    if (labSec) labSec.style.display = 'block';
    document.getElementById('contact').style.display = '';
    document.getElementById('faq').style.display = '';
    document.querySelector('.site-footer').style.display = '';
    document.body.style.overflow = '';
    document.body.classList.add('overflow-x-hidden');
    var bgHeroSrc = document.getElementById('bg').dataset.bgSrc;
    initWebGL('bg', bgHeroSrc);
    setTimeout(function() {
      document.getElementById('bg').classList.add('reveal');
      document.querySelector('.lata2').classList.add('enter');
      document.querySelector('.lata1').classList.add('enter');
      if (window.heroScramble) window.heroScramble();
    }, 200);
    return;
  }

  // 1. Fade in WebGL background
  setTimeout(function() {
    bgGateCanvas.classList.add('visible');
  }, 100);

  // 2. Card appears after bg is visible
  setTimeout(function() {
    gateCard.classList.add('visible');
  }, 1200);

  // 3. Cascade inner elements
  setTimeout(function() {
    gateCard.classList.add('show');
  }, 1600);

  function enterSite() {
    // Set cookie (expires in 1 day)
    document.cookie = 'age_verified=1; max-age=86400; path=/';
    // Fade out gate
    gate.style.transition = 'opacity 0.6s ease';
    gate.style.opacity = '0';

    setTimeout(function() {
      window.scrollTo(0, 0);
      gate.style.display = 'none';
      home.style.display = 'block';
      document.getElementById('section2').style.display = 'block';
      var labSecEnter = document.getElementById('lab-section');
      if (labSecEnter) labSecEnter.style.display = 'block';
      document.getElementById('contact').style.display = '';
      document.getElementById('faq').style.display = '';
      document.querySelector('.site-footer').style.display = '';
      document.body.style.overflow = '';
      document.body.classList.add('overflow-x-hidden');

      // Init WebGL and reveal background
      var bgHeroSrc = document.getElementById('bg').dataset.bgSrc;
      initWebGL('bg', bgHeroSrc);

      setTimeout(function() {
        document.getElementById('bg').classList.add('reveal');
      }, 200);

      // Latas teleport in while bg is still revealing
      setTimeout(function() {
        home.classList.add('scanlines');
        document.querySelector('.lata2').classList.add('enter');
        document.querySelector('.lata1').classList.add('enter');
      }, 600);

      // Hero text scramble after latas
      setTimeout(function() {
        if (window.heroScramble) window.heroScramble();
      }, 1200);
    }, 600);
  }

  btnYes.addEventListener('click', enterSite);

  function showSorry(message) {
    var logoSrc = gate.querySelector('.gate-logo').src;
    var bgSrc = bgGateCanvas.dataset.bgSrc;
    gate.innerHTML =
      '<canvas id="bg-gate-blocked" data-bg-src="' + bgSrc + '" style="position:absolute;inset:-3%;width:106%;height:106%;z-index:0;"></canvas>' +
      '<div style="position:relative;z-index:1;text-align:center;color:#fff;font-family:\'Mona Sans\',sans-serif;font-stretch:semi-expanded;padding:2rem;">' +
        '<img src="' + logoSrc + '" alt="Nine Loko" style="width:300px;margin:0 auto 2rem;display:block;filter:invert(1);" />' +
        '<p style="font-size:1.25rem;font-weight:700;">' + message + '</p>' +
      '</div>';
    initWebGL('bg-gate-blocked', bgSrc);
    setTimeout(function() { window.location.href = 'https://www.google.com'; }, 8000);
  }

  btnNo.addEventListener('click', function() {
    showSorry('Sorry, you must be 21 or older to visit this site.');
  });
});
